import { rankingItems } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '爆': 'bg-primary-500 text-background-50',
  '热': 'bg-accent-500 text-background-50',
  '新': 'bg-secondary-500 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-fire-line"></i>
            实时热榜
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">热搜榜单</h2>
          <p className="text-foreground-600 text-sm">全网最热爆料实时排行，每小时自动刷新</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-2">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group border border-transparent hover:border-secondary-200/70"
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm font-heading ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-100 text-secondary-700'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors truncate font-medium leading-relaxed">
                  {item.title}
                </p>
              </div>
              <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'}`}>
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap hidden sm:block">{item.time}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="#updates" className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer">
            查看更多实时动态
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}